import { ref } from 'vue';

type ISelector = string | HTMLElement;

type IUseLoaderReturn = {
  start: () => void;
  stop: () => void;
};

const isLoader = ref(false);
const loaderCount = ref(0);

export default function useLoader(selector?: ISelector): IUseLoaderReturn {
  const start = (): void => {
    loaderCount.value += 1;
    if (isLoader.value) return;

    let parent: null | HTMLElement;

    switch (typeof selector) {
      case 'string':
        parent = document.querySelector(selector);
        break;
      case 'object':
        parent = selector;
        break;
      default:
        parent = document.querySelector('body');
    }

    if (!parent) return;

    parent.style.position = 'relative';

    const loader = document.createElement('div');
    loader.classList.add('global-loader');
    loader.style.cssText = `
                        display: flex;
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        right: 0;
                        left: 0;
                        background-color: rgba(0,0,0, .2);
                        z-index: 10100;
                    `;

    loader.innerHTML = require('./svg-loader').default;

    parent.appendChild(loader);
    isLoader.value = true;
  };

  const stop = (): void => {
    if (loaderCount.value > 0) {
      loaderCount.value -= 1;
    }

    if (loaderCount.value === 0 && isLoader.value) {
      const loader = document.querySelector('.global-loader');
      if (loader) loader.remove();
      isLoader.value = false;

      document.body.style.removeProperty('position');
    }
  };

  return {
    start,
    stop,
  };
}
